<template lang="pug">
.app-blacklisted-message
  p
    | You have been blocked from sending any messages (ex: invoices, reports, invites etc.) via Hubstaff due to violations of our
    |
    a(
      href="https://hubstaff.com/spam_guidelines"
      rel="noopener noreferrer"
      target="_blank"
    ) spam guidelines
    |
    | and/or
    |
    a(
      href="https://hubstaff.com/terms"
      rel="noopener noreferrer"
      target="_blank"
    ) terms of service.
    |
    | If you feel this is an error, please
    |
    a(href="https://hubstaff.com/contact") contact our support team
    | .
</template>

<script>
export default {
  name: 'AppBlacklistedMessage',
};
</script>
